<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">进展详情</span>
    </div>
    <tool-progress v-if="type==='Tool'" :type="type" :progressInfo="progressInfo" :item="item" :sfQuoteNo="sfQuoteNo"></tool-progress>
<!--    <service-progress v-if="type==='Service'" :type="type" :subType="subType" :progresses="progressInfo" :item="item" :sfQuoteNo="sfQuoteNo"></service-progress>-->
  </div>
</template>


<script>
  import ToolProgress from './ToolProgress'
  import {mapGetters} from 'vuex'
  import EMKT from '../../../../emkt.js'
  export default {
    name: 'ContractProgress',
    components: {
      ToolProgress
    },
    data () {
      return {
        type: 'Service',
        subType: false,
        item: null,
        progressInfo: {},
        sfQuoteNo: null
      }
    },
    computed: {
      ...mapGetters([
        // 'progressInfo'
        'isWapp'
      ])
    },
    // activated () {
    //   this.progressInfo = EMKT.getLocalStorage('progressInfo')
    // },
    mounted () {
      let item = JSON.parse(this.$route.query.item)
      this.sfQuoteNo = this.$route.query.sfQuoteNo
      this.item = item
      console.log('item：', item)
      let progressParam = {id: item.contractNo, type: 1, contractType: item.productType, contractSubType: item.contractType}
      // let progressParam = {}
      // if (item.productType === '产品类') {
      //   progressParam = {id: 'GOSL0158678', type: 1, contractType: '产品类', contractSubType: '非大综合'}
      // } else if (item.productType === '服务类') {
      //   if (item.contractType !== '非大综合') {
      //     progressParam = {id: 'GSZE0219508', type: 1, contractType: '服务类', contractSubType: '非大综合'}
      //   } else {
      //     progressParam = {id: 'GSGC0157106', type: 1, contractType: '服务类', contractSubType: '大综合'}
      //   }
      // }
      // progressParam = {id: 'GOSL0158678', type: 1, contractType: '产品类', contractSubType: '非大综合'}
      // progressParam = {id: 'GSZE0219508', type: 1, contractType: '服务类', contractSubType: '非大综合'}
      // progressParam = {id: 'GSGC0157106', type: 1, contractType: '服务类', contractSubType: '大综合'}
      console.log('progressParam：', progressParam)
      this.gcapi('getContractProgressInfoByContractNo', progressParam).then(res => {
        console.log('进展信息：', res.data.result)
        let result = res.data.result
        let type = 'Tool'
        let subType = false
        if (item.productType === '服务类') {
          type = 'Service'
          if (item.contractType === '大综合') {
            subType = true
          } else {
            subType = false
          }
        } else {
          type = 'Tool'
        }
        this.type = type
        this.subType = subType
        this.progressInfo = result
        console.log('type：', this.type)
        console.log('subType：', this.subType)
        EMKT.setLocalStorage('progressInfo', result)
        // this.UPDATE_PROGRESSINFO(result)
      })
    },
    methods: {
      goBack () {
        this.$router.push({name: 'OrderDetailInfo', query: {status: 2, routeType: 1}})
      }
    }
  }
</script>

<style scoped>
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
  }

  .navshare {
    position: absolute;
    left: 6.67vw;
    width: 10vw;
    height: 10vw;
    padding-top: 2vw;
    color:#ffffff;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }



  .hd {
    display: flex;
    flex-shrink: 0;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }



</style>



// WEBPACK FOOTER //
// ContractProgress.vue?315123c8